module.exports = __webpack_public_path__ + "img/Bitmap-1.ae3ddc49.png";